import styles from '../styles.module.css';
import { companiesFormDataType, handleChangeCompaniesDataType } from './types';
import { baseSchema } from './utils';
import { AdminCardForm } from '@/components/AdminToolComponents/card';
import Input from '@/components/Form/Input';
import Select from '@/components/Form/Select';
import { stateOptions } from '@/constants/locationsStates';
import { formatPhoneNumber } from '@/utils/inputPhone';

export const CompanyForm = ({
  formData,
  handleChangeFormData,
  showEditCompany = true,
  formErrors = {},
  container = 'edit'
}: {
  formData: companiesFormDataType;
  handleChangeFormData: handleChangeCompaniesDataType;
  showEditCompany?: boolean;
  formErrors?: { [k: string]: string };
  container?: 'edit' | 'create';
}) => {
  const requiredFields = Object.keys(baseSchema.shape);

  const getPhoneValue = (phone: string) => {
    return phone?.startsWith('+1') ? phone?.replace('+1', '') : phone;
  };

  const inputComponent = ({
    id,
    label,
    extraProps
  }: {
    id: string;
    label: string;
    extraProps?: any;
  }) => (
    <Input
      label={label}
      type="text"
      value={formData[id as keyof companiesFormDataType] as string}
      onChange={(value: string) => handleChangeFormData(id, value)}
      required={requiredFields.includes(id)}
      readOnly={!showEditCompany}
      error={formErrors[id]}
      {...extraProps}
    />
  );

  const selectComponent = ({
    id,
    label,
    options,
    extraProps
  }: {
    id: keyof companiesFormDataType;
    label: string;
    options: { value: string; label: string }[];
    extraProps?: any;
  }) => (
    <Select
      label={label}
      value={formData[id] as string}
      onChange={(value: string) => handleChangeFormData(id, value)}
      options={options}
      required={requiredFields.includes(id)}
      readOnly={!showEditCompany}
      customClass={styles.adminInput}
      {...extraProps}
    />
  );

  return (
    <AdminCardForm>
      {inputComponent({
        id: 'name',
        label: 'Company Name',
        extraProps: {
          readOnly: container === 'create' ? false : true
        }
      })}
      {inputComponent({
        id: 'postalCode',
        label: 'Zip Code'
      })}
      {inputComponent({
        id: 'address1',
        label: 'Street'
      })}
      {selectComponent({
        id: 'stateProv',
        label: 'State',
        options: stateOptions.map(state => ({
          value: state,
          label: state
        })),
        extraProps: {
          placeholder: 'Select a state',
          value: formData.stateProv ?? ''
        }
      })}
      {inputComponent({
        id: 'address2',
        label: ''
      })}
      {inputComponent({
        id: 'city',
        label: 'City'
      })}
      {inputComponent({
        id: 'contactNumber',
        label: 'Phone Number',
        extraProps: {
          value: showEditCompany
            ? getPhoneValue(formData?.contactNumber)
            : formData?.contactNumber
              ? '+1 ' +
                formatPhoneNumber(getPhoneValue(formData?.contactNumber))
              : '',
          readOnly: !showEditCompany,
          withFlag: true,
          onlyNumbers: true,
          maxLength: 10
        }
      })}
    </AdminCardForm>
  );
};
